import { FC } from "react";
import { WithRouterProps } from "../../helpers/RouterHelper";
import enhanceHomePage from "../../hocs/enhanceHomePage";
import { useQueryError } from "../../hooks/http/useQueryError";
import InvitationAccept from "./InvitationAccept";
import { useFetchInvitation } from "./useFetchInvitation";

interface Props extends WithRouterProps<{ invitationId: string }> {}

const InvitationPage: FC<Props> = (props) => {
  const { invitationId } = props.params;

  // 招待情報をReact Queryで取得
  const { data, isPending, error } = useFetchInvitation(invitationId);
  useQueryError(error);

  return <InvitationAccept isLoading={isPending} invitation={data} />;
};

const pageInfo = { title: "メンバー招待" };
const EnhancedPage = enhanceHomePage(InvitationPage, pageInfo);

export default EnhancedPage;
